import React from 'react';
import { FaCheck, FaStore, FaGem } from 'react-icons/fa';
import { PLAN_COMMERCIAL_UX_ES } from '../../utils/planCommercialUx';
import { PLAN_COMMERCIAL_META_ES } from '../../utils/planDetails';

const tierStyle = {
  basic: {
    ring: 'border-sky-500/30 ring-sky-400/20',
    accent: 'text-sky-300',
    icon: FaStore
  },
  premium: {
    ring: 'border-amber-500/35 ring-amber-400/25',
    accent: 'text-amber-300',
    icon: FaGem
  }
};

/**
 * Tarjeta lateral compacta START o EMPRESA (login desktop/tablet horizontal).
 */
export default function LoginPlanSideCard({ planId = 'basic', onVerPlan }) {
  const copy = PLAN_COMMERCIAL_UX_ES[planId];
  const meta = PLAN_COMMERCIAL_META_ES[planId];
  const styles = tierStyle[planId];
  const Icon = styles.icon;
  const highlights = copy.benefits.slice(0, 4);

  return (
    <aside
      className={[
        'hidden lg:flex flex-col rounded-2xl border bg-e0e3-surface/90 p-4 shadow-elevated ring-1 backdrop-blur-md',
        styles.ring
      ].join(' ')}
    >
      <div className="flex items-center gap-2">
        <span className={`flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 ${styles.accent}`}>
          <Icon className="h-4 w-4" aria-hidden />
        </span>
        <div>
          <p className="text-lg font-bold text-e0e3-foreground">{copy.title}</p>
          <p className="text-[11px] leading-tight text-e0e3-muted">{copy.subtitle}</p>
        </div>
      </div>

      <div className="mt-3 flex flex-wrap gap-1.5">
        <span className="rounded-full bg-white/10 px-2 py-0.5 text-[11px] font-semibold text-e0e3-foreground">
          {meta.includedUsers} usuarios
        </span>
        <span className="rounded-full bg-white/10 px-2 py-0.5 text-[11px] font-semibold text-e0e3-foreground">
          {meta.includedBranches} {meta.includedBranches === 1 ? 'sucursal' : 'sucursales'}
        </span>
      </div>

      <ul className="mt-3 flex-1 space-y-1.5">
        {highlights.map((line) => (
          <li key={line} className="flex gap-2 text-xs leading-snug text-e0e3-foreground">
            <FaCheck className="mt-0.5 h-3 w-3 shrink-0 text-emerald-400" aria-hidden />
            <span>{line}</span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={() => onVerPlan?.(planId)}
        className="mt-3 w-full rounded-lg border border-white/15 bg-white/[0.06] px-2 py-2 text-xs font-semibold text-e0e3-accent-soft transition hover:bg-white/10"
      >
        Ver {copy.title}
      </button>
    </aside>
  );
}
